var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 532.1",
    style: {
      enableBackground: "new 0 0 270 532.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;}\n\t.st2{fill:#D0DE8E;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st4{fill:#F9DB00;}\n\t.st5{fill:#1F54B0;}\n\t.st6{fill:#D03632;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:#93B838;}\n\t.st9{fill:#B1CC40;}\n\t.st10{fill:#CAF741;}\n\t.st11{fill:#FEF7CE;}\n\t.st12{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.9,56.8c7.9,6.2,9.1,7.4,13.9,11.5c2.3,2.1,3.9,5,4.4,8.1c0.3,1.2,0.2,7.3-0.7,9.2 c-1.8,3.7,5.4,6.9-5.6,14.8c-11.3,8-9,23.2-7.6,31.1c2.3,13.1,13.6,13.7,10.7,18.5c-1,1.6-12.6,0.8-20.3-0.2 c-18.2-2.5-1.1-24.4-3.2-39.1c-0.9-6.2,0.5-14.9-8.4-17.9c-7.2-2.4-4.7,2.8-9.7,2.5s-5.3-12.5-19-1.2c-9.3,7.7-5.2,24.2-2.8,33.1 c0.9,3.3,8,11.6,5.1,13.7s-9.3-3.9-13.2-14.8c-2.6-7.5-0.7-17.8-6.3-20.2c-7.8-3.4-8.6-11.6-8.4-17.9s3-11.1,7.6-13.6 c3.4-1.7,6.4-0.6,9.5,2.5c2.6,2.6,3.7,4.2,6,6.6c5.4,5.5,11.2-0.3,10.7-6.2c-0.3-3.3,0.7-5.9,4.4-6.2c3.9-0.2,5.4,1.6,5.3,5.9 c-0.2,9.3,7.6,12.7,13.6,9.7c4.7-2.6,4.8-8.3,3.3-13c-1.3-4.2-1.7-5.2-3.2-9.6C125.7,58.1,134.1,50.7,141.9,56.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.1,37l5.9,17.4l8.8-3c0,0-4-4.6-1.9-7.8c1.5-2.3,5.1-1.6,7.5-1.3c2.6,0.2,5.4-0.8,6.4,2.3 c0.9,2.7-2.6,3.1-3.5,5.6c-0.8,2.3,3.3,6.3-1.2,8c-3.9,1.2-6.4-4.8-6.4-4.8l-9.2,3.2l6.8,20.3l-2.8,1.6L192,37.4L195.1,37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "76,55.3 187.6,13.3 193.6,32.7 190.9,33.1 185.6,17.4 113.4,44.8 123,70.5 120.4,71.6 110.6,45.8  77.1,58.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "207.1,82.6 209.8,81.1 222.1,117.9 219.3,119  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.6,39.3l1-1.6l7.2-1.1l1.4,1.2 M187.6,32.2l1.4,1.2l7.3-1.1l1-1.5 M205.1,85.3l0.4-1.8l6.4-3.5l1.7,0.6  M201.7,79.1l1.7,0.6l6.4-3.6l0.4-1.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.8,506.6c8.8-1.9,15.2-4.5,13.8-10.1c-2.3-9.7-22.9-1.8-38.4-4.2c-17.9-2.8-26.2-5.9-28.9,2.6 c-1.9,6,6.5,8.2,14.4,10.3c5.3,1.4,11,3.7,17.2,4.5C138.4,510.5,146.2,508,152.8,506.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.9,413.1c-8.6,0.1-7.8,11.4-7.9,20.2c-0.1,9.1,0.9,16.8,6.4,16.8c7.8,0.1,8.5-7.8,9.1-17.3 C160,422.9,160.5,412.9,151.9,413.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.5,372c6,0.1,5.9,9.5,5.5,13.5s-1.2,12.4-6.8,11.9c-5.9-0.5-5.4-9.4-5.1-14.1S145.2,371.9,150.5,372"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.6,499.2c-0.4,2-2.3,3.4-4.3,3c-2-0.4-3.4-2.3-3-4.3c0.4-2,2.3-3.4,4.3-3c0,0,0,0,0,0 C161.6,495.2,163,497.2,162.6,499.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.5,434.2c-0.4,2-2.3,3.4-4.3,3c-2-0.4-3.4-2.3-3-4.3c0.4-2,2.3-3.4,4.3-3c0,0,0,0,0,0 C150.5,430.3,151.8,432.2,151.5,434.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.3,434.3c-0.3,2-2.3,3.4-4.3,3c-2-0.3-3.4-2.3-3-4.3s2.3-3.4,4.3-3c0,0,0,0,0,0 C158.3,430.4,159.6,432.3,159.3,434.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M153.7,386.4c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7 C152.1,382.7,153.7,384.4,153.7,386.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M135.6,46.5c0.4-9.5,9.3-10.9,19.2-14.5c8.2-3,12.1-6,19-3.7c10.7,3.7,9,11.3,10.7,17.6 c3.2,11.2,4.5,14.9,10.3,23.1c6,8.4,4.7,28.4,1.8,41.1s-7.5,33.9-11.2,52.1c-4.3,20.9-9.3,36.1-11.9,54.6 c-2.6,19.2,0.6,22-3.3,59.8c-4.8,46.1-7.5,60-27,62.9c-14.4,2.1-24.9-5.4-29.3-16.6c-4.9-12.9-7.3-26.7-7-40.5 c0.4-20,11-28.4,9.6-42.3c-1.7-17.5-5.9-32.7-0.2-66.4c3.1-17.9,9-19.8,16.9-22.5c8.4-2.8,22,1.9,23.9-1.6c2-3.7-3.8-4.4-8-11 c-3.7-5.7-3.8-14.7-4-18c-0.5-8.7,2.9-15.2,6.5-18.6c1.8-1.7,8.2-5.3,8.6-9.7c0.2-2.6-1-3.5-1-5.7c0-1.5,0.7-1.1,1-4.7 c0.3-3.7,0.4-10-4.9-14.3s-6.9-5.9-8.8-7.4C142.6,57.6,135.2,52.2,135.6,46.5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.3,269.9c5.8-1.8,10.6,3.3,12.8,10.4s7.6,10.3,8.1,20.8s-1.9,22-12.5,23.4s-13.7-11.6-14.8-27.1 S120.6,272.5,129.3,269.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M158.3,156.4c4.7,0.7,7.4,10.4-3.8,9.8c-3-0.2-4.7,5.5-5.4,10.4c-1.1,8,4.2,9.3,6.8,15.5 c2.7,6.4,2.3,12.3,2,39.5s0.5,40.5-9.8,41c-7.6,0.4-13.3-13.9-16.8-26.4c-3.2-11.2-9.3-36.6-6.6-63.3 C126.1,169.2,126.3,151.4,158.3,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M160.1,96.9c-0.7,4.2-9.7,7.2-10.4,21.6s9,25.5,16.9,26s8.8-11.2,11.2-23.7s9.2-22.6,6.3-29.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.2,57.5c-6.5-5.4-6.6-12.8-1-17.2c3.8-3,7.4-1.3,12.4-1.6c5.8-0.3,10.6-4.8,16.5-1.5 c7.6,4.1,2.5,12.2,4.3,19.6c0.6,2.6,2.1,4.4,2.2,10.5c0.1,5.2-2.3,7.8-1,11.8s5.4,7,7.1,10.8c2.4,5.1-0.4,8.3-5.9,10.2 c-2.4,0.8-11.9,3.5-16.6-1.1c-2.3-2.3-1.3-3.8-0.9-5.7c0.6-2.8-0.9-4.9-0.9-6.3c0.1-1.6,1.4-2.1,1.1-9.3c-0.2-3.7-1.9-7.1-4.7-9.4 C151.8,64.6,147.1,60.8,143.2,57.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.9,55c-3.3-3.2-4.9-8.4-1.7-12.3c3.4-4.2,7.4-1.6,12.4-2c5.9-0.5,9.6-4.8,15.1-1.3 c5.2,3.3,0.7,12.7,2.5,17.4c2.2,6,4,14.8-1.5,16.4c-4.8,1.4-6.9-1.2-12.7-6.5S150.2,60.2,144.9,55"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M181.1,70.5c-1.4,1.4-4.4,7.5-1.8,10.4c2.1,2.4,7.2,3.1,10.5,2.5c2.6-0.5,2.8-3.2,2.4-4.9 c-0.7-3.3-5.8-1.1-6.6-2.6c-1.1-2.2,2.5-4.6,0.5-6.2C184.9,68.7,182.4,69.2,181.1,70.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.6,48.5c-1.5,0.5-3.3,1.5-3,3.5s2.5,2.6,2.9,4.3s-2,3.6-1.4,5.7c0.4,1.6,2.4,2,4.6,1.9 c2.7-0.1,5-1.9,5-4.4s-2.2-3-3.2-4.5c-1.3-2,0.9-3.8-0.4-5.8C183.4,47.8,181.3,48,179.6,48.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M76.9,361.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S76.9,359.8,76.9,361.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.7,219.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179.7,217.8,179.7,219.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M82.9,360.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S82.9,358.9,82.9,360.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89,360c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S89,358.4,89,360"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79,58.1c0-0.1,0-0.2,0-0.4c0.1-1.7-1.2-3.2-3-3.3c-1.7-0.1-3.2,1.2-3.3,3c0,0.1,0,0.2,0,0.4 c0,0.9,0.4,1.7,1,2.3c-1.5,0.8-2.1,2.8-1.2,4.3c0.8,1.5,2.8,2.1,4.3,1.2c0.5-0.3,1-0.7,1.3-1.3c0.3,0.1,0.6,0.1,0.9,0.1 c1.7-0.1,3.1-1.5,3-3.3C81.9,59.5,80.6,58.2,79,58.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.8,32.9c-0.4,0-0.8,0.1-1.2,0.2l-1.8-8.2c1.7-0.4,2.8-2.1,2.4-3.8s-2.1-2.8-3.8-2.4 c-1,0.2-1.8,0.9-2.2,1.8c-0.9-1.5-2.8-2-4.3-1.1c-0.6,0.3-1,0.8-1.3,1.4c-0.2-1.7-1.8-2.9-3.6-2.7c-1.6,0.2-2.7,1.6-2.7,3.1 c0,0.1,0,0.3,0,0.4c-0.8-1.6-2.6-2.2-4.2-1.5c-1.6,0.8-2.2,2.6-1.5,4.2c0.1,0.1,0.1,0.3,0.2,0.4c-0.4-0.2-0.9-0.3-1.4-0.4 c-1.7-0.1-3.2,1.2-3.3,3c-0.1,1.7,1.2,3.2,3,3.3c0.1,0,0.2,0,0.4,0c0.3,0,0.5,0,0.8-0.1l0.5,3.4L96,35.8c-0.3-1.7-1.9-2.9-3.6-2.6 c-0.7,0.1-1.4,0.5-1.8,1c-0.5-1.3-1.7-2.1-3-2.1c-0.4,0-0.8,0.1-1.2,0.2c0-0.2,0.1-0.5,0.1-0.7c0-1.7-1.4-3.2-3.2-3.2 c-1.7,0-3.2,1.4-3.2,3.2c0,0.5,0.1,1.1,0.4,1.5c-1.7-0.3-3.3,0.9-3.6,2.6s0.9,3.3,2.6,3.6c0.1,0,0.2,0,0.3,0l-0.3,2.4l5,4.8 c-1.5,0.9-2,2.8-1.1,4.3c0.9,1.5,2.8,2,4.3,1.1c1-0.6,1.6-1.6,1.6-2.7c0-0.4-0.1-0.8-0.2-1.1l3.3-0.7l4,2.6c-1,1.5-0.6,3.4,0.9,4.4 c0.5,0.3,1.1,0.5,1.8,0.5c1.4,0,2.6-0.9,3-2.3c0.3,0.1,0.7,0.2,1,0.2c1,0,1.9-0.5,2.5-1.3c0.4,1.7,2,2.8,3.7,2.4 c1.3-0.3,2.3-1.3,2.5-2.7c0.9,1.5,2.9,1.9,4.4,1s1.9-2.9,1-4.4c-0.1-0.2-0.3-0.5-0.5-0.6c0.1,0,0.2,0,0.3,0c1.7,0,3.2-1.4,3.2-3.2 c0,0,0,0,0,0c0-0.3-0.1-0.7-0.2-1c0.3,0.1,0.6,0.1,0.9,0.1c1.7,0,3.2-1.4,3.2-3.1c0,0,0,0,0,0c0-0.3-0.1-0.7-0.2-1 c0.3,0.1,0.6,0.1,0.9,0.1c1.7-0.1,3.1-1.6,3-3.3C127.6,34.3,126.3,33,124.8,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.2,435c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S110.2,433.3,110.2,435"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.9,357.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S112.9,356.1,112.9,357.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136.4,112.3c-0.6-1-1.7-1.5-2.8-1.5c0-0.1,0-0.3,0-0.4c1.7,0.3,3.3-0.9,3.6-2.6c0.3-1.6-0.7-3.1-2.2-3.5 c1-1,1.1-2.6,0.4-3.8c-0.3-0.4-0.7-0.8-1.1-1.1c0.1-0.3,0.2-0.6,0.2-0.9c0-0.7-0.3-1.5-0.8-2c0.5-0.9,0.5-2.1,0-3 c1.2-1.1,1.3-3,0.2-4.2c-0.6-0.6-1.4-1-2.2-1c-0.8,0-1.5,0.3-2.1,0.9c-0.5-0.3-1-0.4-1.5-0.4c-0.9,0-1.7,0.4-2.2,1 c-1.4-0.8-3.1-0.3-4,1c-1.1-1.2-3-1.3-4.2-0.2c-0.6,0.5-0.9,1.2-1,2c-0.9-0.5-1.9-0.6-2.8-0.1c0.1-0.3,0.2-0.7,0.2-1 c0-1.7-1.4-3-3-3c-0.6,0-1.1,0.2-1.6,0.5c0-0.1,0-0.1,0-0.2c0-1.7-1.4-3-3-3c-1,0-1.9,0.5-2.4,1.3c-0.5-0.3-1-0.5-1.6-0.5 c-1.4,0-2.6,1-2.9,2.4c-1.3-1.2-3.2-1.2-4.5,0.1c-0.6,0.6-0.9,1.4-0.9,2.3c-1.7,0.3-2.8,2-2.5,3.7c0.1,0.4,0.3,0.8,0.5,1.2 c-1.4,1.1-1.6,3.1-0.5,4.4c0.5,0.6,1.3,1.1,2.1,1.1c-0.6,0.8-0.8,1.7-0.5,2.7c-1.7-0.2-3.3,1-3.6,2.7c-0.1,0.7,0,1.5,0.4,2.1 c0.1,0.1,0.1,0.2,0.2,0.3l-0.1,0.1c-1.5,0.9-2,2.9-1.1,4.4c0.5,0.9,1.5,1.5,2.6,1.5c-1.6,0.7-2.3,2.6-1.6,4.2 c0.5,1,1.4,1.7,2.6,1.8c-1.4,1.1-1.6,3.1-0.5,4.4c0.6,0.8,1.6,1.2,2.6,1.2c-1.3,1.1-1.5,3.1-0.4,4.4c0.6,0.7,1.5,1.2,2.5,1.1 c-1.4,1.1-1.6,3.1-0.5,4.4c0.5,0.7,1.4,1.1,2.2,1.2c-1,1.3-0.8,3.2,0.5,4.2c1.3,1,3.2,0.8,4.2-0.5c0.2-0.2,0.3-0.5,0.4-0.8 c1.3,1,3.2,0.8,4.2-0.5c0.4-0.5,0.6-1.2,0.6-1.8c0-0.3,0-0.5-0.1-0.8c1.1,0,2.1-0.5,2.7-1.4c0.1-0.1,0.2-0.3,0.2-0.4 c1.3,0.4,2.8-0.1,3.6-1.3c1,1.3,2.9,1.6,4.2,0.6c0.7-0.6,1.2-1.4,1.2-2.3c0-0.5-0.1-1-0.4-1.4c1.3-0.1,2.4-0.9,2.8-2.2 c1.4,0.9,3.2,0.6,4.2-0.8c0.2-0.4,0.4-0.8,0.5-1.2c0.2,0.1,0.5,0.1,0.7,0.1c1.2,0,2.3-0.8,2.8-1.9c0.4,0.2,0.8,0.3,1.2,0.3 c1.7,0,3-1.3,3-3c0-0.6-0.2-1.3-0.6-1.8c1-0.5,1.6-1.5,1.6-2.6c0-0.6-0.2-1.3-0.6-1.8C136.8,115.8,137.2,113.8,136.4,112.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128,54.8c-0.7,0.4-1.1,1-1.4,1.7c-0.4,0.1-0.7,0.2-1,0.3c-1.1,0.7-1.7,2-1.4,3.2c-0.3,0.1-0.5,0.2-0.8,0.3 c-1,0.6-1.6,1.7-1.5,2.8c-1.6-0.3-3.2,0.8-3.5,2.4c-0.3,1.6,0.8,3.2,2.4,3.5c0.2,0,0.4,0.1,0.7,0c-0.1,0.6,0,1.3,0.3,1.9 c0.8,1.4,2.7,1.9,4.1,1.1c1-0.6,1.6-1.7,1.5-2.8c0.3-0.1,0.6-0.2,0.9-0.3c1.4-0.8,1.9-2.6,1.1-4.1c-0.4-0.6-0.9-1.1-1.6-1.3 c0.1-0.4,0.1-0.8,0-1.2c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.4,1.1-1,1.4-1.7c0.4-0.1,0.7-0.2,1-0.3c1.4-0.8,1.9-2.7,1.1-4.1 C131.2,54.5,129.4,54,128,54.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.2,50.5c0-0.2,0.1-0.4,0.1-0.6c0-1.7-1.4-3-3-3c-1.2,0-2.2,0.7-2.7,1.8c-1.7,0.1-2.9,1.5-2.9,3.1 c0.1,1.7,1.5,2.9,3.1,2.9c0.3,0,0.7-0.1,1-0.2c1.2,1.2,3.1,1.2,4.2,0c0.6-0.6,0.9-1.3,0.9-2.1C125.8,51.8,125.6,51.1,125.2,50.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M69.3,454.2c0,3.3-2.7,6.1-6.1,6s-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C66.6,448.1,69.3,450.9,69.3,454.2 C69.3,454.2,69.3,454.2,69.3,454.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.5,523.6c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C111.8,517.5,114.5,520.2,114.5,523.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.5,520.4c0,3.3-2.7,6.1-6.1,6c-3.3,0-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C124.8,514.3,127.5,517,127.5,520.4 C127.5,520.4,127.5,520.4,127.5,520.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139,524c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C136.3,517.9,139,520.7,139,524"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.6,512.4c0,3.3-2.7,6.1-6.1,6c-3.3,0-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6 C153.8,506.4,156.6,509.1,156.6,512.4C156.6,512.4,156.6,512.4,156.6,512.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91,452.3c0,3.3-2.7,6.1-6.1,6s-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C88.3,446.2,91,448.9,91,452.3 C91,452.3,91,452.3,91,452.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M152.5,523c0,5-4.1,9.1-9.1,9.1s-9.1-4.1-9.1-9.1c0-5,4.1-9.1,9.1-9.1h0C148.4,513.9,152.5,518,152.5,523"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M170.4,400.2c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C167.6,394.2,170.3,396.9,170.4,400.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.6,387.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C132.8,381.5,135.6,384.2,135.6,387.6C135.6,387.6,135.6,387.6,135.6,387.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.2,421.9c0,3.3-2.7,6.1-6.1,6s-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C123.5,415.9,126.2,418.6,126.2,421.9 C126.2,421.9,126.2,421.9,126.2,421.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M83.6,445.1c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C80.9,439,83.6,441.8,83.6,445.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M129.6,379.6c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C126.8,373.5,129.6,376.2,129.6,379.6C129.6,379.6,129.6,379.6,129.6,379.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.6,291.5c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C177.9,285.4,180.6,288.1,180.6,291.5C180.6,291.4,180.6,291.4,180.6,291.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.5,268.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C179.7,262.7,182.5,265.4,182.5,268.8C182.5,268.8,182.5,268.8,182.5,268.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M183.4,245.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C180.7,239.8,183.4,242.5,183.4,245.8C183.4,245.8,183.4,245.8,183.4,245.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.4,314.8c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1l0,0 C174.7,308.8,177.4,311.5,177.4,314.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.6,354c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C227.9,347.9,230.6,350.7,230.6,354"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.3,334.5c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C109.6,328.5,112.3,331.2,112.3,334.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.6,340c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C102.9,333.9,105.6,336.7,105.6,340"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.8,320.1c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C106.1,314,108.8,316.8,108.8,320.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96.8,322.3c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C94.1,316.2,96.8,318.9,96.8,322.3L96.8,322.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.4,291.1c0,3.3-2.8,6-6.1,6s-6-2.8-6-6.1c0-3.3,2.7-6,6.1-6C82.7,285,85.4,287.7,85.4,291.1 C85.4,291.1,85.4,291.1,85.4,291.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.8,310.4c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C98.1,304.3,100.8,307,100.8,310.4C100.8,310.3,100.8,310.4,100.8,310.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.9,259.6c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C70.1,253.5,72.9,256.2,72.9,259.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.6,45.5c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C83.9,39.5,86.6,42.2,86.6,45.5C86.6,45.5,86.6,45.5,86.6,45.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M79.5,49.7c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C76.8,43.7,79.5,46.4,79.5,49.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.9,127.8c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C113.2,121.8,115.9,124.5,115.9,127.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.7,125.8c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C105,119.8,107.7,122.5,107.7,125.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.1,114.7c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C100.4,108.6,103.1,111.3,103.1,114.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.1,104.7c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C107.3,98.7,110.1,101.4,110.1,104.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.4,97.3c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C112.7,91.2,115.4,93.9,115.4,97.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.5,96.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C102.8,90.7,105.5,93.4,105.5,96.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115,116.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0.1,0 C112.3,110.2,115.1,112.9,115,116.3C115.1,116.3,115.1,116.3,115,116.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.4,102.9c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C119.6,96.8,122.4,99.5,122.4,102.9C122.4,102.9,122.4,102.9,122.4,102.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.4,113c0,3.4-2.6,6.1-6,6.1c-3.4,0-6.1-2.6-6.1-6c0-3.4,2.6-6.1,6-6.1c0,0,0,0,0.1,0 C119.6,107,122.4,109.7,122.4,113C122.4,113.1,122.4,113.1,122.4,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133,103.5c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0.1,0,0.1,0 C130.3,97.4,133.1,100.1,133,103.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.1,93.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C127.3,87.2,130.1,90,130.1,93.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.2,111.7c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C131.4,105.6,134.2,108.3,134.2,111.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.2,192.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C97.4,186.5,100.1,189.3,100.2,192.6C100.2,192.6,100.2,192.6,100.2,192.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.4,182.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C97.6,176.8,100.4,179.5,100.4,182.8C100.4,182.8,100.4,182.8,100.4,182.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90,173.2c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1C87.3,167.2,90,169.9,90,173.2 C90,173.2,90,173.2,90,173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M82,163.1c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0.1,0 C79.3,157,82,159.7,82,163.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.1,160.7c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6-6.1 C87.3,154.6,90.1,157.4,90.1,160.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.1,150.4c0,3.3-2.7,6.1-6.1,6s-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C82.4,144.3,85.1,147.1,85.1,150.4 C85.1,150.4,85.1,150.4,85.1,150.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.1,141.1c0,3.4-2.7,6.1-6.1,6c-3.4,0-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C91.3,135,94.1,137.7,94.1,141.1 C94.1,141.1,94.1,141.1,94.1,141.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M78.3,72.4c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1l0,0C75.6,66.4,78.3,69.1,78.3,72.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.7,90.1c0,3.3-2.7,6.1-6.1,6c-3.3,0-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C71,84,73.7,86.7,73.7,90.1 C73.7,90.1,73.7,90.1,73.7,90.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.2,81.4c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C71.5,75.3,74.2,78,74.2,81.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.2,101.5c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C74.5,95.4,77.2,98.1,77.2,101.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84,111.4c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0C81.3,105.4,84,108.1,84,111.4 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M87.1,121.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C84.4,115.8,87.1,118.5,87.1,121.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.7,138.2c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C82,132.1,84.7,134.8,84.7,138.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.6,133c0,3.4-2.6,6.1-6,6.1c-3.4,0-6.1-2.6-6.1-6c0-3.4,2.6-6.1,6-6.1c0,0,0,0,0.1,0 C87.8,127,90.6,129.7,90.6,133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M78.4,130.6c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C75.7,124.5,78.4,127.3,78.4,130.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.2,109c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C69.5,102.9,72.2,105.7,72.2,109"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M65.5,99c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0C62.8,92.9,65.5,95.7,65.5,99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M62.5,86.7c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1l0,0C59.8,80.6,62.5,83.3,62.5,86.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75,119.2c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0.1,0,0.1,0 C72.3,113.1,75,115.8,75,119.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.8,205c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C108.1,198.9,110.8,201.7,110.8,205"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.6,200.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C103.9,194.2,106.6,197,106.6,200.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.3,207.5c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C97.6,201.4,100.3,204.1,100.3,207.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.2,215.4c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C109.5,209.4,112.2,212.1,112.2,215.4C112.2,215.4,112.2,215.4,112.2,215.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186,6.1c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6,6-6.1C183.3,0,186,2.7,186,6.1 C186,6,186,6,186,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.4,7.6c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C193.7,1.6,196.4,4.3,196.4,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M169.6,12.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C166.8,6.5,169.6,9.2,169.6,12.6C169.6,12.6,169.6,12.6,169.6,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.1,11.2c0,3.3-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6,6-6.1C175.3,5.2,178.1,7.9,178.1,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M157.7,18.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C155,12.5,157.7,15.2,157.7,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M145.7,22.2c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C143,16.1,145.7,18.8,145.7,22.2C145.7,22.2,145.7,22.2,145.7,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.2,37.8c0,3.3-2.7,6.1-6.1,6s-6.1-2.7-6-6.1c0-3.3,2.7-6,6.1-6C115.5,31.7,118.2,34.4,118.2,37.8 C118.2,37.8,118.2,37.8,118.2,37.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.9,27.5c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1l0,0 C123.2,21.4,125.9,24.1,125.9,27.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.7,18.1c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C131,12.1,133.7,14.8,133.7,18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.6,26.8c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C131.9,20.7,134.6,23.5,134.6,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.1,35.8c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1C105.3,29.7,108.1,32.4,108.1,35.8 C108.1,35.8,108.1,35.8,108.1,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.2,45.9c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C97.5,39.8,100.2,42.6,100.2,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.3,113.2c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1l0,0 C210.6,107.1,213.3,109.8,213.3,113.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M227,129.1c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1S227,125.8,227,129.1 L227,129.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M222.2,87.3c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C219.5,81.2,222.2,83.9,222.2,87.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M219.2,65.2c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C216.5,59.1,219.2,61.8,219.2,65.2C219.2,65.2,219.2,65.2,219.2,65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.9,63.1c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C200.2,57,202.9,59.7,202.9,63.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.6,49c0,3.4-2.6,6.1-6,6.1c-3.4,0-6.1-2.6-6.1-6c0-3.4,2.6-6.1,6-6.1c0,0,0.1,0,0.1,0 C195.9,43,198.6,45.7,198.6,49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.6,122.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C202.9,116.5,205.6,119.2,205.6,122.6C205.6,122.6,205.6,122.6,205.6,122.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M162.5,171.9c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C159.8,165.9,162.5,168.6,162.5,171.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.2,180.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C158.5,174.3,161.2,177,161.2,180.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173.3,204.1c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C170.6,198.1,173.3,200.8,173.3,204.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123,70.8c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0.1,0 C120.3,64.8,123,67.5,123,70.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106,70.2c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C103.3,64.2,106,66.9,106,70.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96.8,72.7c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C94.1,66.6,96.8,69.3,96.8,72.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.1,69.1c0,3.4-2.7,6.1-6.1,6c-3.4,0-6.1-2.7-6-6.1c0-3.3,2.7-6.1,6.1-6C83.4,63,86.1,65.7,86.1,69.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.4,60.8c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1l0,0C95.7,54.7,98.4,57.4,98.4,60.8 C98.4,60.8,98.4,60.8,98.4,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.5,59.4c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C103.8,53.3,106.5,56,106.5,59.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.7,62.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1l0,0C89,56.2,91.7,58.9,91.7,62.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.5,79.3c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C101.7,73.2,104.5,75.9,104.5,79.3C104.5,79.3,104.5,79.3,104.5,79.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.4,57.3c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1l0,0 C112.7,51.2,115.4,54,115.4,57.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.5,65.7c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C113.8,59.7,116.5,62.4,116.5,65.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.5,73.6c0,3.4-2.7,6.1-6.1,6.1c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C131.8,67.5,134.5,70.2,134.5,73.6L134.5,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.7,78.7c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.3,2.7-6.1,6.1-6.1c0,0,0,0,0,0 C121,72.7,123.7,75.4,123.7,78.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.2,82.5c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1c0,0,0,0,0,0 C128.5,76.4,131.2,79.1,131.2,82.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik4);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_4.86a706b9adfa17f8c5c2c2f45fdad2aa.svg";
export { ForwardRef as ReactComponent };